import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import NoData from './components/sharable/fallbacks/NoData';
import ContentLoader from './components/sharable/loaders/ContentLoader';
import ButtonLoader from './components/sharable/loaders/ButtonLoader';
import Vuelidate from 'vuelidate';
import Multiselect from 'vue-multiselect';
import optional from 'lodash.get';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import lodash from 'lodash';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import './plugins';
import './assets/scss/index.scss';
import Statistics from '@/components/statistics/Statistics';
import LoginRegisterAs from '@/components/sharable/modals/authentication/LoginRegisterAs';
import EmailLogin from '@/components/sharable/modals/authentication/EmailLogin';
import i18n from './i18n';
import moment from 'moment';
import VueCarousel from 'vue-carousel';

Vue.config.productionTip = false;

// Global Components
Vue.component('NoData', NoData);
Vue.component('ContentLoader', ContentLoader);
Vue.component('ButtonLoader', ButtonLoader);
Vue.component('multiselect', Multiselect);
Vue.component('Statistics', Statistics);
Vue.component('LoginRegisterAs', LoginRegisterAs);
Vue.component('EmailLogin', EmailLogin);

// Global Plugins
Vue.use(Vuelidate);

Vue.prototype.$eventBus = new Vue();
Vue.prototype.$optional = optional;
Vue.prototype.$isLoggedIn = store.getters.isLoggedIn;
Vue.prototype.$user = store.getters.user;
Vue.prototype.$lodash = lodash;

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueCarousel);

Vue.mixin({
  computed: {
    isMobile() {
      var match = window.matchMedia || window.msMatchMedia;
      if (match) {
        var mq = match('(pointer:coarse)');
        return mq.matches;
      }
      return false;
    },
  },
  methods: {
    translate(text) {
      return this.$t(text);
    }
  },
  filters: {
    formatDate(date) {
      return moment(date).format('lll');
    },
    formatDateTime(date) {
      return moment(date).format('MMM DD, YYYY h:mm A');
    }
  }
});

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app');
